export const isNullable = <T>(value: T | null | undefined): value is null | undefined =>
  value === undefined || value === null

export const isNonNullable = <T>(value: T): value is NonNullable<T> =>
  !isNullable(value)
